module.exports = Promise.all([
    import("tap-asset-manager/controller/block-ctrl").then(dep => dep.default),
    import("tap-asset-manager/controller/browser-view-ctrl").then(dep => dep.default),
    import("tap-asset-manager/controller/manage-view-ctrl").then(dep => dep.default),
    import("tap-asset-manager/controller/new-view-ctrl").then(dep => dep.default),
    import("tap-asset-manager/controller/sharer-twitter-ctrl").then(dep => dep.default),
    import("tap-asset-manager/directives/asset-share-buttons").then(dep => dep.default),
    import("tap-asset-manager/service/asset-embed-code-generator").then(dep => dep.default),
    import("tap-asset-manager/service/asset-patcher").then(dep => dep.default),
    import("tap-asset-manager/service/asset-storage").then(dep => dep.default),
    import("tap-asset-manager/service/sharer-twitter").then(dep => dep.default),
    import("tap-asset-manager/service/referral-code").then(dep => dep.default),
]);
